import { RenderPage } from "@chaimera/editor";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { api } from "../lib/api.ts";
import { BUILDER_API } from "../lib/artwork-builder.ts";
import type { ActiveAusPostSpec } from "../lib/auspost-spec.ts";

/**
 * Headless print target for the DIY Design Tool. Browser Run loads it with a
 * render token (?token=) and prints it to PDF; __root.tsx renders it bare.
 */
export const Route = createFileRoute("/render/$id")({
  component: Render,
});

function Render() {
  const { id } = Route.useParams();
  const ausPost = useQuery({
    queryKey: ["auspost-spec"],
    queryFn: () => api.get<ActiveAusPostSpec>("/auspost-spec"),
  });
  if (ausPost.isError || (ausPost.isFetched && !ausPost.data)) {
    return <pre id="chaimera-error">AusPost spec is not loaded</pre>;
  }
  if (!ausPost.data) return null;
  return <RenderPage artworkId={id} baseUrl={BUILDER_API} spec={ausPost.data.spec} />;
}
